import { render, staticRenderFns } from "./contratoFichaVenda.vue?vue&type=template&id=28f29833&"
import script from "./contratoFichaVenda.vue?vue&type=script&lang=js&"
export * from "./contratoFichaVenda.vue?vue&type=script&lang=js&"
import style0 from "./contratoFichaVenda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTooltip,QDialog,QCard,QCardSection,QSeparator,QBar,QSpace,QStep,QStepper,QInput,QIcon,QSelect,QBadge,QCheckbox,QSpinner,QStepperNavigation,QList,QItem,QItemSection,QAvatar,QItemLabel,QCardActions});qInstall(component, 'directives', {ClosePopup,Ripple});
